import algoliasearch from "algoliasearch/lite";
import { directive as vClickOutsideDirective } from "v-click-outside";
import _debounce from "lodash/debounce";

export default {
  props: {
    index: String,
    value: String,
    name: String,
    algoliaConfig: Object,
    placeholder: String,
    hasErrors: Boolean,
  },

  data() {
    return {
      isOpen: false,
      algoliaClient: algoliasearch(this.$env.algolia().appId, this.$env.algolia().token, {
        timeouts: {
          connect: this.$utils.constants.ALGOLIA_CONNECT_TIMEOUT,
          read: this.$utils.constants.ALGOLIA_READ_TIMEOUT,
        },
      }),
    };
  },

  methods: {
    onSelect,
    handleScroll,
    debouncedSearch: _debounce((refine, value) => refine(value), 500),
  },

  directives: {
    clickOutside: vClickOutsideDirective,
  },
};

function onSelect(item) {
  this.isOpen = false;
  this.$emit("select", item);
  this.$emit("input", item);
}

function handleScroll({ target }, refine) {
  if (target.scrollTop + target.clientHeight > target.scrollHeight - 150) {
    refine();
  }
}
